/**
 * Acciones sobre ordenes
 * @type {string[]}
 */
TiposOrdenesActionsService.$inject = ['$log', 'dialogService'];
export default function TiposOrdenesActionsService($log, dialogService) {

    var TAG = 'TiposOrdenesActionsService: ';
    var DIALOG_EDIT_TIPOORDEN_TEMPLATE = require('./edit/dialog-tiposordenes-edit.html');
    var DIALOG_EDIT_TIPOORDEN_ID = 'dialog-tiposordenes-edit';

    return {
        addTipoOrden: addTipoOrden,
        editTipoOrden: editTipoOrden
    };

    function editTipoOrden(tipoOrdenId) {
        var titulo = 'Editar tipo orden ' + tipoOrdenId;
        var options = {title: titulo};
        var datos = {tipoOrdenId: tipoOrdenId};
        var opcionesExtra = {deshabilitarBotones: true};

        return dialogService.open(DIALOG_EDIT_TIPOORDEN_ID, DIALOG_EDIT_TIPOORDEN_TEMPLATE, datos, options, opcionesExtra);
    }

    function addTipoOrden() {
        var titulo = 'Añadir tipo orden';
        var options = {title: titulo};
        var datos = {};
        var opcionesExtra = {deshabilitarBotones: true};

        return dialogService.open(DIALOG_EDIT_TIPOORDEN_ID, DIALOG_EDIT_TIPOORDEN_TEMPLATE, datos, options, opcionesExtra);
    }
}